<div class="pi pi-times" mat-button (click)="dialogRef.close()" style="position: absolute; top: 27px; right: 45px; color: gray;"></div>
<div>
  <mat-dialog-content>
    <p-table [value]="evidenceCentralItems"
             [rows]="100"
             [paginator]="true"
             [pageLinks]="3"
             [rowsPerPageOptions]="[10, 20, 50, 100]"
             [style]="{'margin-top':'10px'}"
             selectionMode="single"
             [resizableColumns]="true"
             [reorderableColumns]="true"
             dataKey="clientITProfileId"
             #dashboardTable>

      <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
        <tr class="ui-widget-header">
          <td (click)="selectDevice(item)">
              <span>{{item.name}}</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </mat-dialog-content>
</div>
